// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2z2uY","right":"Footer_right__1fdZn","buttons":"Footer_buttons__2Bxep"};